import React from 'react';
import styles from './Input.module.scss';
import Cross from '@src/assets/Cross.png';
import Eye from '@src/assets/Eye.png';
import EyeClose from '@src/assets/EyeClose.png';
import CheckOK from '@src/assets/CheckOK.png';
import Search from '@src/assets/Search.png';

type RegistrationInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
    title?: string;
    type?: string;
    hasError?: boolean;
    isPassword?: boolean;
    hidePassword?: boolean;
    setHidePassword?: Function;
    clearInput?: () => void;
    defaultValue?: number;
    id?: string;
    name?: string;
    isSearch?: boolean;
    widthLimit?: string;
    showCheckIcon?: boolean;
    errorMessage?: string;
    disabledAddress?: boolean;
};

const RegistrationInput: React.FC<RegistrationInputProps> = ({
    title,
    type = 'text',
    hasError,
    isPassword,
    hidePassword,
    setHidePassword,
    clearInput,
    value,
    onChange,
    placeholder,
    width,
    disabled,
    id,
    name,
    isSearch,
    widthLimit,
    showCheckIcon,
    errorMessage,
    disabledAddress,
    ...props
}) => {

    const handleNumericInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const numericValue = e.target.value.replace(/[^\d,]/g, '');
        const parts = numericValue.split(',');

        const sanitizedValue = parts.length > 1 ? `${parts[0]},${parts[1].substring(0, 2)}` : numericValue;

        if (onChange) {
            onChange({
                ...e,
                target: { ...e.target, value: sanitizedValue },
            });
        }
    }

    return (
        <div className={styles.wrapper} style={{ width: widthLimit ? widthLimit : '100%' }}>
            <p className={styles.title}>{title}</p>
            <div className={`${styles.inputContainer} ${hasError ? styles.error : ''}`} data-error={errorMessage}>
                <input
                    className={`${styles.input} ${hasError ? styles.errorBackground : ''}`}
                    type={type === "number" ? "text" : type}
                    placeholder={placeholder}
                    value={value}
                    onChange={type === "number" ? handleNumericInput : onChange}
                    onInput={type === "number" ? handleNumericInput : undefined}
                    disabled={disabled || disabledAddress}
                    style={{ width }}
                    id={id}
                    name={name}
                    onBlur={props.onBlur}
                    {...props}
                />
                {isPassword && (
                    <button
                        type="button"
                        className={styles.togglePassword}
                        onClick={() => setHidePassword && setHidePassword(!hidePassword)}
                    >
                        {hidePassword ? <img src={EyeClose} alt='EyeClose' width={28} height={28}/> : <img src={Eye} alt='Eye' width={28} height={16}/>}
                    </button>
                )}
                {value && !disabled && (
                    <button
                        type="button"
                        className={styles.clearIcon}
                        onClick={() => clearInput && clearInput()}
                        style={{ right: isPassword || isSearch ? '52px' : '16px' }}
                    >
                        {clearInput && <img src={Cross} alt="Clear" width={22} height={22} />}
                    </button>
                )}
                {disabled && showCheckIcon && <div className={styles.checkOk}><img src={CheckOK} alt="CheckOk" width={22} height={16} /></div>}
                {isSearch && <div className={styles.togglePassword}><img src={Search} alt="Search" width={20} height={20} /></div>}
            </div>
        </div>
    );
};

export default RegistrationInput;